import {gql} from '@apollo/client'

export const CREATE_PASSPHRASE = gql`
  mutation CreatePassphrase($input: CreatePassphraseInput!) {
    createPassphrase(input: $input)
  }
`

export const UNLOCK_LOCKED = gql`
  mutation UnlockLocked($input: UnlockLockedInput!) {
    unlockLocked(input: $input) {
      token
      resealAfter
    }
  }
`

export const LOCK_LOCKED = gql`
  mutation LockLocked {
    lockLocked
  }
`

export const UPDATE_LOCKED_SETTINGS = gql`
  mutation UpdateLockedSettings($input: LockedSettingsInput!) {
    updateLockedSettings(input: $input) {
      id
      preferences {
        driveView
        lockedHidden
        lockedResealAfter
      }
    }
  }
`

export const CHANGE_PASSPHRASE = gql`
  mutation ChangePassphrase($input: ChangePassphraseInput!) {
    changePassphrase(input: $input)
  }
`

export const RESET_LOCKED = gql`
  mutation ResetLocked {
    resetLocked
  }
`
